import {SearchQueryParams} from '../../models/search-query-params.model';
import {ProductBase, ProductConfigurationType} from '../../models/product.model';
import {ValidationError} from '../../models/validation-error.model';

export namespace ProductActions {
    export class GetListPage {
        static readonly type = 'ProductActions.GetListPage';

        constructor(public params?: SearchQueryParams) {
        }
    }

    export class Add {
        static readonly type = 'ProductActions.Add';

        constructor(public configurationType: ProductConfigurationType, public data: ProductBase) {
        }
    }

    export class FormFailure {
        static readonly type = 'ProductActions.FormFailure';

        constructor(public readonly validationErrors: ValidationError[]) {
        }
    }

    export class FieldList {
        static readonly type = 'ProductActions.FieldList';

        constructor(public readonly params?: {}) {
        }
    }

    export class ClearValidationErrors {
        static readonly type = 'ProductActions.ClearValidationErrors';

        constructor(public readonly fields: string[] = []) {
        }
    }
}
